import { render } from "./ProvincesView.vue?vue&type=template&id=17413161&scoped=true"
import script from "./ProvincesView.vue?vue&type=script&lang=js"
export * from "./ProvincesView.vue?vue&type=script&lang=js"

import "./ProvincesView.vue?vue&type=style&index=0&id=17413161&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17413161"]])

export default __exports__